<template>
  <div>
      <div class="table" v-if="showGrid">
        <table style="width: 100%;">
          <thead class="table__head">
          <tr>
            <th class="table_select_checkbox">
              <p4a-checkbox
                :disabled="false"
                :selected="false"
                :textHidden="true"
                :checked="allSelected"
                @change="selectAll">
              </p4a-checkbox>
            </th>
            <th class="table_image"></th>
            <th v-for="head in headers" :key="head.Id" :class="head.Caption === '' ? 'table_header_image' : 'table_header_text'">
              <template v-if="!isImageColumn(head)">
                <span :title="head.Caption">{{ head.Caption }}</span>
              </template>
              <template v-else>
                <img  :src="require('../../assets/img/doc_icons/' + getColumnHeaderImage(head.FieldName))" alt="''"/>
              </template>
            </th>
          </tr>
          </thead>
          <tbody class="table__body">
          <tr :class="row.IsActive ? 'selected' : ''"
            class="table_row"
            v-for="(row, index) in body"
            :key="row.DocumentVersionId"
            :ref="`trversion-${row.DocumentVersionId}`"
            :index="index"
            :id="row.DocumentVersionId"
            :verid="row.DocumentVersionId"
            v-click-outside="closeContextMenu"
            @contextmenu="showContextMenu($event, row, index)"
            @click="selectRow(row, index)"
            @dblclick="rowDobleClick($event, row)"
          >
            <td class="table_select_checkbox">
              <p4a-checkbox
                :disabled="false"
                :textHidden="true"
                :checked="row.IsSelected"
                @change="check(row.DocumentVersionId )"
                >
              </p4a-checkbox>
            </td>
            <td class="table__image sticky" >
              <img :src="require('../../assets/img/grid/' + row.Properties.FileType)" :alt="row.Properties.FileType"/>
            </td>
            <td v-for="header in headers" :key="header.Id + '-version-column'">
              <template v-if="header.Caption === ''">
                <img :src="require('../../assets/img/doc_icons/' + getColumnImage(row.Properties[header.FieldName]))" :alt="header.FieldName"/>
              </template>
              <template v-else>
                <span class="text_row" v-html="formatCellValue(row.Properties[header.FieldName], header.Caption,header.ValueType)"></span>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>
import mixins from 'mixins'
import * as folderApi from 'api/folderApi.js'

export default {
  name: 'VersionGridTable',
  mixins: [mixins],
  props: {
    showGrid: Boolean,
    headers: {
      default: function () {
        return []
      },
      type: Array
    },
    gridBody: {
      default: function () {
        return []
      },
      type: Array
    }
  },
  data () {
    return {
      selectedFolderId: -1,
      body: this.gridBody
    }
  },
  computed: {
    allSelected () {
      return this.body.length > 0 && this.body.every(x => x.IsSelected === true)
    }
  },
  watch: {
    gridBody () {
      this.body = this.gridBody
    }
  },
  methods: {
    selectRow (row, index) {
      this.$emit('rowVersionSelected', row.DocumentVersionId)
      this.body.forEach(element => {
        let rowDOM = this.$refs[`trversion-${element.DocumentVersionId}`]

        if (rowDOM.length > 0) {
          if (element.DocumentVersionId === row.DocumentVersionId) {
            window.parent.versions.selRow = rowDOM[0]
            rowDOM[0].classList.add('selected')
            element.IsActive = true
          } else {
            rowDOM[0].classList.remove('selected')
            element.IsActive = false
          }
        }
      })
      this.closeContextMenu()
    },
    rowDobleClick (e, row) {
      if (!row.Properties.IsExpected && !row.Properties.IsPaperDocument) {
        let source = this.$refs[`trversion-${row.DocumentVersionId}`]
        if (source != null && source.length > 0) {
          let top = window.parent.getTop()
          if (!top) { top = window }
          top.download(source[0])
        }
      }
      e.preventDefault()
    },
    check (id) {
      let item = this.body.find(selectedItem => selectedItem.DocumentVersionId === id)
      if (item.IsSelected) {
        this.$emit('rowVersionUnChecked', id)
      } else {
        this.$emit('rowVersionChecked', id)
      }
      item.IsSelected = !item.IsSelected
    },
    showContextMenu (e, row, index) {
      if (row.IsActive !== true) {
        this.selectRow(row, index)
      }
      if (window.parent && window.parent.ContextMenuVersion) {
        window.parent.ContextMenuVersion.ShowContextMenu(e.x + Number(window.top.document.getElementById('navbarLeft').clientWidth) + 10, e.y + 120)
      }
      e.preventDefault()
    },
    closeContextMenu: function () {
      if (window.parent && window.parent.ContextMenuVersion) {
        window.parent.ContextMenuVersion.Hide()
      }
    },
    selectAll () {
      let self = this
      let as = self.allSelected
      folderApi.checkAllDocumentVersions(!as).then(result => {
        let storageObject = JSON.parse(window.localStorage.getItem('selectionState'))
        if (result === 'true') {
          self.body.forEach(item => {
            item.IsSelected = true
          })
          storageObject.versions = self.body.map(x => x.DocumentVersionId)
        } else {
          self.body.forEach(item => {
            item.IsSelected = false
          })
          storageObject.versions = []
        }
        window.localStorage.setItem('selectionState', JSON.stringify(storageObject))
        // Update the cookie
        let date = new Date()
        let storageString = JSON.stringify(storageObject)
        date.setDate(date.getDate() + 1)
        document.cookie = 'ds_sls=' + storageString + '; expires=' + date + '; path=/;'
      }).catch(() => {
        alert(self.$i18n.t('DocumentGrid.checkVersionError'))
      })
    },
    formatCellValue (html, fieldName, valueType) {
      let txt = document.createElement('textarea')
      txt.innerHTML = html
      let itemslookup = txt.value.split(this.lookupFieldSeparator(valueType))
      if (itemslookup.length > 1) {
        return this.setLookupFields(itemslookup)
      }

      if (fieldName === 'Days left') {
        let res = html !== null ? html : ''
        return `<span style='color: red'>${res}</span>`
      }
      return this.sanitizerHTML(html)
    },
    setLookupFields (itemsMultiple) {
      let value = ''
      let resultMultiple = itemsMultiple.length - 1 > 0 ? ' + ' + (itemsMultiple.length - 1) + ' more' : ''
      itemsMultiple.forEach(item => {
        value += item.toString().trim() + '\n'
      })
      return itemsMultiple[0] + `<span style='color: blue' title='${value}'>${resultMultiple}</span>`
    },
    lookupFieldSeparator (ValueType) {
      if (ValueType === 'vt_lookup_hierarchy') return '|'
      if (ValueType === 'vt_lookup_multiple') return '-'
    },
    isImageColumn (column) {
      return column.Caption === '' && this.getColumnHeaderImage(column.FieldName) != null
    }
  }
}
</script>

<style lang="scss" scoped>
.text_row {
  width: 100%;
  min-width: 20px;
  left: 0;
  top: 50%;
  line-height: 14px;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  text-overflow: ellipsis;
}

.table_row {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.table_image {
  width: 40px;
  max-width: 40px;
  min-width: 40px;
}
.table_header_image {
  min-width: 25px;
  max-width: 25px;
  width: 25px;
}
.table_header_text {
  min-width: 40px;
  max-width: 100px;
}
.table_select_checkbox {
  width: 30px;
  max-width: 30px;
  min-width: 30px;
  padding-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/grid/versionGridTable.vue